import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import {
  DocumentVerificationSessionDTO,
  DocumentVerificationSessionList,
  DocumentVerificationSessionCreateRequestDTO,
  DocumentVerificationSessionUpdateRequestDTO,
  DocumentVerificationSessionDeleteRequestDTO,
  DocumentVerificationSessionReadByIdRequestDTO,
  DocumentVerificationSessionReadByMasterIdRequestDTO,
  DocumentVerificationSessionResolvePublicRequestDTO,
  DocumentVerificationSessionResolvePublicResponseDTO,
  DocumentVerificationSessionUploadPublicResponseDTO,
  DocumentVerificationSessionCompletePublicRequestDTO,
  DocumentVerificationSessionCompletePublicResponseDTO
} from "./documentVerificationSession.interface";

import {
  DocumentVerificationSession_Create,
  DocumentVerificationSession_Update,
  DocumentVerificationSession_Delete,
  DocumentVerificationSession_ReadByMasterId,
  DocumentVerificationSession_ReadAll,
  DocumentVerificationSession_ReadById,
  DocumentVerificationSession_ExternalReadById,
  DocumentVerificationSession_ExternalDelete,
  DocumentVerificationSession_ResolvePublic,
  DocumentVerificationSession_UploadPublic,
  DocumentVerificationSession_CompletePublic
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root"
})
export class DocumentVerificationSessionService {

  constructor() {}

  http = inject(HttpClient);

  DocumentVerificationSession_Create(data: DocumentVerificationSessionCreateRequestDTO): Observable<DocumentVerificationSessionDTO> {
    return this.http.post<DocumentVerificationSessionDTO>(DocumentVerificationSession_Create, data);
  }

  DocumentVerificationSession_Update(data: DocumentVerificationSessionUpdateRequestDTO): Observable<DocumentVerificationSessionDTO> {
    return this.http.post<DocumentVerificationSessionDTO>(DocumentVerificationSession_Update, data);
  }

  DocumentVerificationSession_Delete(data: DocumentVerificationSessionDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(DocumentVerificationSession_Delete, data);
  }

  DocumentVerificationSession_ExternalDelete(data: DocumentVerificationSessionDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(DocumentVerificationSession_ExternalDelete, data);
  }

  DocumentVerificationSession_ReadById(data: DocumentVerificationSessionReadByIdRequestDTO): Observable<DocumentVerificationSessionDTO> {
    return this.http.post<DocumentVerificationSessionDTO>(DocumentVerificationSession_ReadById, data);
  }

  DocumentVerificationSession_ExternalReadById(data: DocumentVerificationSessionReadByIdRequestDTO): Observable<DocumentVerificationSessionDTO> {
    return this.http.post<DocumentVerificationSessionDTO>(DocumentVerificationSession_ExternalReadById, data);
  }

  DocumentVerificationSession_ReadByMasterId(data: DocumentVerificationSessionReadByMasterIdRequestDTO): Observable<DocumentVerificationSessionList> {
    return this.http.post<DocumentVerificationSessionList>(DocumentVerificationSession_ReadByMasterId, data);
  }

  DocumentVerificationSession_ReadAll(): Observable<DocumentVerificationSessionList> {
    return this.http.get<DocumentVerificationSessionList>(DocumentVerificationSession_ReadAll);
  }

  /*
   * P0-07 ADDITIONS
   *
   * These methods do not change the current working flow.
   * Start using them only after the matching backend and Ocelot routes exist.
   */

  DocumentVerificationSession_ResolvePublic(
    data: DocumentVerificationSessionResolvePublicRequestDTO
  ): Observable<DocumentVerificationSessionResolvePublicResponseDTO> {
    return this.http.post<DocumentVerificationSessionResolvePublicResponseDTO>(
      DocumentVerificationSession_ResolvePublic,
      data
    );
  }

  DocumentVerificationSession_UploadPublic(
    token: string,
    documentTypeCode: string,
    file: File
  ): Observable<DocumentVerificationSessionUploadPublicResponseDTO> {
    const formData = new FormData();

    formData.append("token", token);
    formData.append("documentTypeCode", documentTypeCode);
    formData.append("file", file);

    return this.http.post<DocumentVerificationSessionUploadPublicResponseDTO>(
      DocumentVerificationSession_UploadPublic,
      formData
    );
  }

  DocumentVerificationSession_CompletePublic(
    data: DocumentVerificationSessionCompletePublicRequestDTO
  ): Observable<DocumentVerificationSessionCompletePublicResponseDTO> {
    return this.http.post<DocumentVerificationSessionCompletePublicResponseDTO>(
      DocumentVerificationSession_CompletePublic,
      data
    );
  }

}
